import HeaderMainButton from './header-main__button.vue';
import { createApp } from 'vue';

export const headerMain = () => {
	const element = document.querySelector('.header-main');
	const buttons = element.querySelectorAll('.header-main__button-component');

	buttons.forEach((button) => {
		if (!button) return;
		const { type, href, icon } = button.dataset;
		const app = createApp(HeaderMainButton, { type, href, icon });
		app.use(window.app.pinia);
		app.mount(button);
	});
};
